import React, { memo } from 'react'
import styles from './VNMenuQuantity.module.scss'

const VNMenuQuantity = ({ value, color = 'inherit' }) => {
  if (value) {
    return <span className={styles.quantity}>{value}</span>
  }

  return <span className={styles.add} style={{ color }} />
}

export default memo(VNMenuQuantity)
